<template>
  <v-container>
    <v-row>
      <v-spacer></v-spacer>
      <v-col :cols="getColWidth" class="headline"
        ><h1 class="white--text basker-text">Charity Sponsors</h1></v-col
      >
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col :cols="getColWidth" class="headline">
        <h3 class="white--text basker-text">
          Charity Sponsors Battle Royale could not be made possible without the
          continuous support from our sponsors. If you would like to become a
          sponsor, please <a :href="sponsorLink" class="text-link" target="_blank">click here</a>.
        </h3>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-row v-if="loading" justify="center">
      <v-progress-circular indeterminate color="yellow"></v-progress-circular>
    </v-row>

    <v-row v-else>
      <v-spacer> </v-spacer>
      <v-col cols="3" v-for="(photo, index) in photos" :key="index">
        <v-img contain :src="photo" />
      </v-col>
      <v-spacer> </v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import { supabase } from '@/supabase'
import { mapState } from 'vuex'

export default {
  name: "Sponsors",

  data: () => ({
    buttons: ["Home", "Tickets", "Contact", "More"],
    photos: [],
    loading: true
  }),
  computed: {
    ...mapState([
      'sponsorLink'
    ]),
    getColWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 10;
        case "sm":
          return 10;
        case "md":
          return 6;
        case "lg":
          return 6;
        case "xl":
          return 6;
      }
    },
  },
  async mounted() {
    try {
      // List all files in the sponsors bucket
      const { data: files, error } = await supabase
        .storage
        .from('sponsors')
        .list('', {
          limit: 100,
          sortBy: { column: 'name', order: 'asc' }
        })

      if (error) throw error

      // Filter out any folders and get public URLs for images
      for (const file of files) {
        if (file.name && !file.name.endsWith('/')) {
          const { data } = supabase
            .storage
            .from('sponsors')
            .getPublicUrl(file.name)

          this.photos.push(data.publicUrl)
        }
      }
    } catch (err) {
      console.error('Failed to load sponsor images:', err)
    } finally {
      this.loading = false
    }
  },
};
</script>

<style scoped>
.headline {
  text-align: center;
}
</style>
